import appConfig from "config";

import { useArrangementState } from "./ArrangementContext";

/**
 * Link to the market's General Price List PDF (hosted on the CDN, one file per
 * market slug). Renders nothing when the case has no market slug. Styling
 * matches the surrounding body text by default; pass `className` to adjust
 * spacing/size at the call site.
 */
export default function GplLink({ className = "" }: { className?: string }) {
  const { config } = useArrangementState();
  const marketSlug = config?.case_context?.market_slug?.toLowerCase();

  if (!marketSlug) return null;

  const gplUrl = `${appConfig.cdnHost}/files/gpl/gpl_${marketSlug}.pdf`;

  return (
    <p className={`text-base text-soil ${className}`}>
      We stand behind our transparent pricing — review our{" "}
      <a
        href={gplUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        General Price List
      </a>
      .
    </p>
  );
}
